export const USER_NOTIFICATIONS_POLLING_REFRESH_TIME = 60 * 1000;
export const USER_NOTIFICATIONS_ITEMS_PER_PAGE = 20;
export const AVATAR_SIZE = 32;
